import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import {
  ContainerProcedure,
  SubContainer
} from '../../../certificates-constancies/type1/info/components';
import { BackButton, FileUploader } from '../../../../components';
import { Block } from '../../../../../../components';
import Step from '../../UpdatePhoto/Register/components/Step';
import { ProcedureInfoComponent } from '../info/components/ProcedureInfoComponent';
import Select from '../../../../../../reusables/Select';
import {
  ToggleHeader,
  TextTitle
} from '../../../certificates-constancies/type1/register/components';
import Spinner from '@/presentation/components/Spinner';
import QuitPageModal from '../../CertificateOfStudies/dialogs/QuitPageModal';
import MyModal from '@/presentation/modules/procedures/components/Modals/MyModal';
import Processing from '@/presentation/components/Processing';
import CheckBox from '../../../scholarships/bse/components/CheckBox';
import ReusableButton from '@/presentation/reusables/Button';
import {
  convertBytesToMegabytes,
  convertFileToBase64,
  getFileExtension
} from '@/presentation/reusables/Upload/helpers';
import IDHelpers from '@/core/helpers/IDHelper';
import ContentModalTwoButtons from '@/presentation/modules/procedures/components/ContentModalTwoButtons';
import ModalConfirmation from '../../../../components/Modal/Modal';

const Container = styled.div`
  color: #161d1f;
  padding: 24px;
  background-color: #fff;
  border-radius: 4px;
  margin: 16px 0px 32px 0px;
  width: 100%;
  gap: 16px;
  display: flex;
  flex-direction: column;
`;
const ContentGray = styled.div`
  color: #161d1f;
  background-color: #ecf4f9;
  border-radius: 8px;
  padding: 12px;
`;

const PeriodsPse = (list: any) => {
  if (!list || list?.length === 0) return [];
  return list.map((period: any) => ({
    id: period.id,
    name: period.name
  }));
};

const PseRegisterView = ({
  handlerBackButton,
  procedureInfo,
  open,
  period,
  termsConditions,
  register,
  registerSuccess,
  isProcessingRegister,
  isLoadingProcedure,
  sendFiles,
  goToProgress,
  goToPayments,
  badPath,
  defaultMessage,
  requestMessage,
  payed,
  checkDocumentValidation,
  checkDeclarationValidation,
  fileValidation,
  systemErrorValidation,
  manualPath
}: any) => {
  const { openBack, setOpenBack } = open;
  const { selectPeriod, setSelectPeriod } = period;
  const periodSelectedName = procedureInfo?.detail?.periodApplied?.find(
    (p: any) => p.id === selectPeriod
  );

  const { terms, setTerms } = termsConditions;

  const { success } = registerSuccess;
  const { setBase64, base64 } = sendFiles;

  const { successBadPath } = badPath;
  const { defaultError } = defaultMessage;
  const { payPSE } = payed;
  const { checkDocument, setCheckDocument } = checkDocumentValidation;
  const { checkDeclaration, setCheckDeclaration } = checkDeclarationValidation;
  const { fileError, setFileError } = fileValidation;
  const { systemError, errorInRegisterInsuranceValidation } =
    systemErrorValidation;
  const [validDocument, setValidDocument] = useState(false);
  const [tryAgain, setTryAgain] = useState(false);

  const formatFiles = async (xFiles: File[]) => {
    const arr: any[] = [];
    await Promise.all(
      xFiles.map(async (file: File) => {
        arr.push({
          base64: await convertFileToBase64(file),
          id: String(IDHelpers.generateID()),
          fileName: file.name,
          originalName: file.name,
          ext: getFileExtension(file.name),
          path: null,
          weight: convertBytesToMegabytes(file.size)
        });
      })
    );
    setBase64([...base64, ...arr]);
  };

  useEffect(() => {
    if (tryAgain) {
      setBase64([]);
      formatFiles([]);
      setFileError(false);
      setValidDocument(false);
      setCheckDocument(false);
      setCheckDeclaration(false);
      setTryAgain(false);
    }
    if (manualPath) {
      goToProgress();
    }
  }, [tryAgain, manualPath]);

  return (
    <ContainerProcedure>
      <SubContainer style={{ marginBottom: 24 }}>
        <BackButton onClick={() => setOpenBack(true)} />
      </SubContainer>
      <Processing isOpen={isProcessingRegister} />
      <SubContainer>
        {isLoadingProcedure || !procedureInfo ? (
          <Spinner />
        ) : (
          <>
            {procedureInfo && (
              <>
                <ToggleHeader
                  name="Validación de seguro de salud"
                  amount={procedureInfo.amount}
                  duration={procedureInfo.duration}
                  date={procedureInfo.endDate}
                  childContent={<ProcedureInfoComponent inRegister />}
                />
                <TextTitle title="Progreso" />
                <Block customized padding="28px 0px 45px 8px">
                  <Step
                    name={procedureInfo.steps[0].name}
                    order={procedureInfo.steps[0].order}
                  >
                    <Container>
                      <Select
                        items={PeriodsPse(procedureInfo?.detail?.periodApplied)}
                        onChange={(e) => setSelectPeriod(e)}
                        isDisabled={requestMessage?.state === 'PENDIENTE'}
                        value={
                          procedureInfo?.detail?.periodApplied?.length === 1
                            ? procedureInfo?.detail?.periodApplied[0]?.id
                            : selectPeriod
                        }
                        placeholder="Elige un ciclo"
                        itemCount={2}
                        itemName={'name'}
                        itemValue={'id'}
                        label={'Ciclo a validar:'}
                      />
                      <ContentGray
                        style={{
                          display: 'flex',
                          gap: 12,
                          flexDirection: 'column'
                        }}
                      >
                        <b>Validación automática</b>
                        <ul style={{ listStyle: 'initial', marginLeft: 20 }}>
                          <li>
                            Descarga tu Registro de Afiliados en PDF desde la{' '}
                            web de{' '}
                            <a
                              style={{
                                color: '#5B36F2',
                                textDecorationLine: 'underline'
                              }}
                              href="https://app1.susalud.gob.pe/registro/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              SUSALUD
                            </a>
                            .
                          </li>
                          <li>
                            Luego, súbelo aquí para validar tu afiliación
                            automáticamente. Si tienes dudas revisa este{' '}
                            <a
                              style={{
                                color: '#5B36F2',
                                textDecorationLine: 'underline'
                              }}
                              href="https://drive.google.com/file/d/1uYJUcLKFRUHSan1zwGKccpJjijIvCegh/view?usp=drive_link"
                              target="_blank"
                              rel="noreferrer"
                            >
                              instructivo
                            </a>
                            .
                          </li>
                        </ul>
                      </ContentGray>
                      <div
                        style={{
                          display: 'flex',
                          gap: 8,
                          flexDirection: 'column'
                        }}
                      >
                        <b>Adjunta lo siguiente:</b>
                        <ul style={{ listStyle: 'initial', marginLeft: 20 }}>
                          <li>
                            PDF de tu registro de afiliados, generado en la web{' '}
                            de SUSALUD.
                          </li>
                        </ul>
                      </div>
                      <FileUploader
                        title=""
                        allowedFormats=".pdf"
                        displayFormats="PDF"
                        maxFileSize={1}
                        maxAllowFiles={1}
                        clearAll={tryAgain}
                        onFilesError={(e: any) => {
                          setValidDocument(e.filesCount > 0);
                          setBase64([]);
                        }}
                        onFilesClean={() => setBase64([])}
                        onFilesReady={(myFiles: any) => formatFiles(myFiles)}
                      />
                      <CheckBox
                        firstLabel="Declaro que el documento adjunto ha sido válidamente obtenido desde el portal de SUSALUD, y es veraz y fidedigno."
                        value="1"
                        checked={checkDocument}
                        handleOnChange={() => setCheckDocument(!checkDocument)}
                        style={{
                          fontSize: 12,
                          fontWeight: 400,
                          lineHeight: '16px'
                        }}
                      />
                      <CheckBox
                        firstLabel={`Declaro que el seguro que tengo contratado estará vigente durante todo el ciclo de ${periodSelectedName?.name}.`}
                        value="2"
                        checked={checkDeclaration}
                        handleOnChange={() =>
                          setCheckDeclaration(!checkDeclaration)
                        }
                        style={{
                          fontSize: 12,
                          fontWeight: 400,
                          lineHeight: '16px'
                        }}
                      />
                      <ReusableButton
                        style={{ padding: '0 24px', marginTop: 8 }}
                        disabled={
                          base64?.length < 1 ||
                          !validDocument ||
                          !checkDocument ||
                          !checkDeclaration
                        }
                        onClick={() => register(true)}
                        data-testid="btn-register-pse"
                      >
                        Validar
                      </ReusableButton>
                    </Container>
                  </Step>
                  <Step
                    name={procedureInfo.steps[1].name}
                    order={procedureInfo.steps[1].order}
                    disabled
                    isLast
                  >
                    <></>
                  </Step>
                </Block>
              </>
            )}
          </>
        )}
      </SubContainer>

      <QuitPageModal
        handlerBack={handlerBackButton}
        handlerClose={() => setOpenBack(false)}
        show={openBack}
      />
      <MyModal
        show={successBadPath}
        data={{
          title: '¡La solicitud fue enviada exitosamente!'
        }}
        handlerClick={() => goToProgress()}
        handlerClose={() => goToProgress()}
      />
      <MyModal
        show={terms}
        data={{
          title: 'Términos y Condiciones',
          description:
            'Acepto que utilicen mis datos (documento de identidad) para realizar la validación automática y puedan anular el pago'
        }}
        handlerClick={() => setTerms(false)}
        handlerClose={() => setTerms(false)}
      />
      <MyModal
        show={defaultError}
        data={{
          description: requestMessage?.state
        }}
        handlerClick={() => {
          handlerBackButton();
        }}
        handlerClose={() => handlerBackButton()}
      />
      <MyModal
        show={payPSE}
        data={{
          title: 'Tu validación se realizó con éxito',
          description:
            'Para que te devuelvan tu pago realizado del Programa de Salud Estudiantil (PSE), solicita tu <a href="/tramites/ticketera/registro?v=TA0045">reembolso.</a>'
        }}
        handlerClick={() => goToProgress()}
        handlerClose={() => goToProgress()}
      />
      <ModalConfirmation show={success} handleClose={goToProgress}>
        <ContentModalTwoButtons
          img={null}
          showInfo={false}
          title="Tu validación se realizó con éxito"
          subtitle="El pago del Programa de Salud Estudiantil (PSE) ya no se reflejará en tus pagos pendientes."
          textButton1="Aceptar"
          onClickButton1={goToProgress}
          textButton2="Ir a pagos"
          onClickButton2={goToPayments}
        />
      </ModalConfirmation>
      <ModalConfirmation show={fileError} handleClose={() => setTryAgain(true)}>
        <ContentModalTwoButtons
          img={null}
          withSeparator
          showInfo={false}
          title="No pudimos validar tu documento"
          subtitle0="Revisa tu PDF y vuelve a intentarlo. Recuerda que se debe descargar de la web de SUSALUD."
          subtitle="Si deseas, puedes enviar este PDF adjunto a una validación manual con SAE. <b>Tiempo de espera es de 3 días hábiles.</b>"
          textButton1="Volver a intentarlo"
          onClickButton1={() => setTryAgain(true)}
          textButton2="Enviar a validación manual"
          onClickButton2={() => {
            setFileError(false);
            register(false);
          }}
        />
      </ModalConfirmation>
      <MyModal
        show={systemError || errorInRegisterInsuranceValidation}
        data={{
          title: 'Ocurrió un problema inesperado',
          description: 'Por favor, vuelve a intentarlo en unos momentos.'
        }}
        handlerClick={() => {
          handlerBackButton();
        }}
        handlerClose={() => handlerBackButton()}
      />
    </ContainerProcedure>
  );
};

export default PseRegisterView;
